const SPACE_REGEX = /\s/;

// for QName validation as per http://www.w3.org/TR/REC-xml/#NT-NameChar
const QNAME_REGEX = /^([a-z][\w-.]*:)?[a-z_][\w-.]*$/i;

// for Reference validation as per BPMN Schema (QName - Namespace)
const ID_REGEX = /^[a-z_][\w-.]*$/i;

/**
 * checks whether the reference value is valid
 *
 * @param {ModdleElement} element
 * @param {String} referenceValue
 * @param {Function} translate
 *
 * @return {String} error message
 */
export function isReferenceVald(referenceValue, translate) {
  if (!referenceValue) {
    return translate('Reference must not be empty.');
  }

  return validateReference(referenceValue, translate);
}

export function validateReference(referenceValue, translate) {

  if (containsSpace(referenceValue)) {
    return translate('Reference must not contain spaces.');
  }

  if (!ID_REGEX.test(referenceValue)) {

    if (QNAME_REGEX.test(referenceValue)) {
      return translate('Reference must not contain prefix.');
    }

    return translate('Reference must be a valid QName.');
  }
}

export function containsSpace(value) {
  return SPACE_REGEX.test(value);
}